import {
  createSupplier,
  deleteSupplier,
  listOptionSuppliers,
  listSuppliers,
  listSuppliersNext,
  updateSupplier,
} from '../thunks/marketplace-suppliers';
import { handlePending, handleRejected } from './utils';

export const marketplaceSuppliersReducers = (builder) => {
  // list suppliers
  builder
    .addCase(listSuppliers.fulfilled, (state, action) => {
      const suppliers = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.suppliers.value = suppliers;
      state.suppliers.offset = offset;
      state.suppliers.hasMore = suppliers.length > 0;
      state.suppliers.loading = false;
      state.suppliers.initialised = true;
    })
    .addCase(listSuppliers.pending, (state) => {
      if (!state.suppliers.initialised) {
        state.suppliers.loading = true;
      }
    })
    .addCase(listSuppliers.rejected, (state) => handleRejected(state, 'suppliers'));

  builder
    .addCase(listSuppliersNext.fulfilled, (state, action) => {
      const suppliers = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.suppliers.value = [...state.suppliers.value, ...suppliers];
      state.suppliers.offset = offset;
      state.suppliers.hasMore = suppliers.length > 0;
      state.suppliers.loading = false;
    })
    .addCase(listSuppliersNext.pending, (state) => {
      if (!state.suppliers.initialised) {
        state.suppliers.loading = true;
      }
    })
    .addCase(listSuppliersNext.rejected, (state) => handleRejected(state, 'suppliers'));

  builder
    // list option suppliers
    .addCase(listOptionSuppliers.fulfilled, (state, action) => {
      state.options.suppliers.value = action.payload || [];
      state.options.suppliers.loading = false;
    })
    .addCase(listOptionSuppliers.pending, (state) => {
      state.options.suppliers.loading = true;
    })
    .addCase(listOptionSuppliers.rejected, (state) => {
      state.options.suppliers.loading = false;
    });

  // create supplier
  builder
    .addCase(createSupplier.fulfilled, (state, action) => {
      const suppliers = [...state.suppliers.value];
      const supplier = action.payload;
      suppliers.push(supplier);
      state.suppliers.value = suppliers;
      state.newSupplierForm.loading = false;
    })
    .addCase(createSupplier.pending, (state) => handlePending(state, 'newSupplierForm'))
    .addCase(createSupplier.rejected, (state) => handleRejected(state, 'newSupplierForm'));

  // update supplier
  builder
    .addCase(updateSupplier.fulfilled, (state, action) => {
      const suppliers = [...state.suppliers.value];
      const updatedSupplier = action.payload;
      const supplierIndex = suppliers.findIndex((supplier) => supplier.id === updatedSupplier.id);
      if (supplierIndex >= 0) {
        suppliers[supplierIndex] = { ...suppliers[supplierIndex], ...updatedSupplier };
      }
      state.suppliers.value = suppliers;
      state.newSupplierForm.loading = false;
    })
    .addCase(updateSupplier.pending, (state) => handlePending(state, 'newSupplierForm'))
    .addCase(updateSupplier.rejected, (state) => handleRejected(state, 'newSupplierForm'));

  // delete supplier
  builder.addCase(deleteSupplier.fulfilled, (state, action) => {
    const suppliers = [...state.suppliers.value];
    const supplierId = action.payload;
    const supplierIndex = suppliers.findIndex((supplier) => supplier.id === supplierId);
    if (supplierIndex >= 0) {
      suppliers.splice(supplierIndex, 1);
    }
    state.suppliers.value = suppliers;
  });
};
